import { TutorialStep } from "..";
import { TUTORIAL_EPOCH, TUTORIAL_OVERKILL_CONDITION, TUTORIAL_TRAIN_COUNT } from "../constants";

export const InspTrainSteps: TutorialStep[] = [
  {
    target: "#select-ai-server",
    content: "학습 진행시킬 서버를 선택해줍니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "#insp-img-table",
    disableOverlayClose: true,
  },
  {
    target: "#insp-img-table",
    content: "앞 단계에서 넣은 데이터셋을 기준으로 학습/검증 리스트가 자동으로 나뉩니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#open-train-option",
    content: "클릭하여 학습 옵션을 설정합니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#defect-preview-modal",
    content: "특정 값을 조절해서 학습에 쓰일 디펙옵션을 설정할 수 있습니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#train-option",
    content: `학습할 이미지 수와 학습을 반복할 횟수(epoch)를 지정합니다.\n튜토리얼에서는 이미지 ${TUTORIAL_TRAIN_COUNT}장, epoch ${TUTORIAL_EPOCH}으로 미리 설정해두었습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#model-save-option",
    content: `학습/검증 후 저장할 모델의 조건을 설정합니다.\n튜토리얼에서는 모든 epoch의 모델이 저장되도록 과검률 ${TUTORIAL_OVERKILL_CONDITION}% 이하로 미리 설정해두었습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#start-epoch-train",
    content: "학습 진행 버튼을 눌러 학습을 시작해봅시다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    // 학습 요청 성공 후 InspProjectTable이 다음 스텝으로 넘긴다 (클릭 즉시 넘기면 실패해도 넘어감)
    nextTrigger: "#epoch-train-progress",
    disableOverlayClose: true,
  },
];
